module.exports = __webpack_public_path__ + "img/ICBCT.c21a5706.png";